<!--
 * @Description: 我的运单
 * @Author: ganjia
 * @Date: 2019-10-11 10:09:33
 -->
<template>
  <div class="main-wrap waybill">
    <div class="waybill-top">
        <el-button type="primary" @click="exportOpen" :loading="exportLoading" icon="iconfont icondaochu" class="h40 exportOpen" plain>{{ $lang('导出') }}</el-button>
        <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
      <div class="waybill-topLeft"  id="jmsSearch">
        <el-form label-position="top" :model="searchParam" ref="seach" :inline="true">
          <el-form-item :label="$lang('下单时间')" prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始日期')"
              :end-placeholder="$lang('结束日期')"
              class="commonSize"
              @change="selectDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$lang('运单编号')" prop="waybillNos">
            <base-input-tag-new
              :style="'width:' + (lang === 'CN' ? '210px' : '420px')"
              v-model="searchParam.waybillNos"
              :placeholder="$lang('请输入运单编号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag">
            </base-input-tag-new>
          </el-form-item>
          <el-form-item :label="$lang('收件人联系电话')" prop="receiverMobilePhone">
            <el-input v-model="searchParam.receiverMobilePhone" :placeholder="$lang('请输入收件人联系电话')" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="margin-top: 20px;" type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{ $lang('查询') }} </el-button>
          </el-form-item>
          <el-form-item>
            <el-button style="margin-top: 20px;" type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }} </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="waybill-bottom">
      <div class="waybill-nav">
        <div class="waybill-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(index)" :class="{ active: tabActive === index }">
          {{ item.waybillStatusName }}<span class="waybill-nav-item-count">{{ item.count }}</span>
        </div>
      </div>

      <JmsTableScroll
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-del="rowDel"
        @size-change="sizeChange"
        @selection-change="selectionChange"
        @current-change="currentChange"
      >
        <template slot="waybillStatusCode" slot-scope="data">
          <div>
            <!-- 201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件 -->
            <span v-show="data.row.waybillStatusCode == 201">{{ $lang('已揽件') }}</span>
            <span v-show="data.row.waybillStatusCode == 202">{{ $lang('已发件') }}</span>
            <span v-show="data.row.waybillStatusCode == 203">{{ $lang('运送中') }}</span>
            <span v-show="data.row.waybillStatusCode == 204">{{ $lang('派件中') }}</span>
            <span v-show="data.row.waybillStatusCode == 205">{{ $lang('已签收') }}</span>
            <span v-show="data.row.waybillStatusCode == 206">{{ $lang('退件中') }}</span>
            <span v-show="data.row.waybillStatusCode == 207">{{ $lang('已退件') }}</span>
            <span v-show="data.row.waybillStatusCode == 208">{{ $lang('已拒收') }}</span>
          </div>
        </template>
        <!-- 运单号 -->
             <template slot="waybillNo" slot-scope="data">
                  <el-tooltip placement="top">
                        <div slot="content" @click="handleCopy(data)" style="cursor:pointer">{{ $lang('复制运单号') }}</div>
                        <span @click="getExpressTracking(data.row.waybillNo)" class="getExpressTracking">{{data.row.waybillNo}}</span>
                </el-tooltip>
            </template>

        <template slot="menu" slot-scope="data">
          <div>
            <!-- 查看按钮 -->
            <el-button @click="rowView(data.row)" type="text" :title="$lang('查看')">{{ $lang('查看') }}</el-button>
            <!-- 删除按钮 -->
            <!--                    <el-button v-show="data.row.waybillStatusCode==205||data.row.waybillStatusCode==207" @click="rowDel({ id: data.row.id })" type="text" icon="iconfont iconshanchu font-16"></el-button>-->
            <el-button
              v-show="data.row.waybillStatusCode == 205 || data.row.waybillStatusCode == 207"
              @click="rowDel({ waybillNo: data.row.waybillNo })"
              type="text"
            >{{ $lang('删除') }}</el-button>
          </div>
        </template>
      </JmsTableScroll>
    </div>

    <!-- 订单详情弹框组件 -->
    <bullet ref="bullet" :viewDialogVisible="viewDialogVisible" @closeDetails="closeDetails" @imgDialogChange="imgDialogChange" :bulletTitle="2" :rowData="rowData"></bullet>
    <!-- 导出订单弹框组件 -->
    <export-componet
      ref="exportComponet"
      :cityOptions="cityOptions"
      :exportVisible="exportVisible"
      :idsLength="selection.length"
      :exportData="exportData"
      @export-close="exportClose"
      @export-fn="exportFn"
    ></export-componet>

    <!-- 下载中心 -->
    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"></ExportDownloadDialog>
  </div>
</template>
<script>
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin.js'
import { waybillOrder, countByStatus, asyExportWaybill, waybillDelete, getDetailById, queryCustomerOrderSource } from '@api/module/customer'
import bullet from '@components/base/BaseBullet.vue'
import exportComponet from '@components/base/BaseExport.vue'
import { cityOptions, RESPONSE_SUCCESS } from '@constants'
import { commonFun } from '@utils/common'
import { mapGetters } from 'vuex'
import ExportDownloadDialog from '@components/export-download-dialog/ExportDownloadDialog.vue'
import dayjs from 'dayjs'
export default {
  name: 'Waybill',
  mixins: [mixin],
  components: {
    JmsTableScroll,
    bullet,
    exportComponet,
    ExportDownloadDialog
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const space = 90 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const noewDate = dayjs(new Date().getTime()).format('YYYY-MM-DD')
          const maxTime = new Date(noewDate + ' 23:59:59').getTime()
          return time.getTime() < minTime || time.getTime() > maxTime
        }
      },
      COM_HTTP: {
        reqList: waybillOrder,
        // reqExcel: waybillExport,
        reqExcel: asyExportWaybill,
        reqDel: waybillDelete,
        reqDetail: getDetailById
      },
      isShowFirst: false,
      searchParam: {
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0],
        endTime: commonFun.GetTodayDate()[1],
        waybillNos: [], // 运单号
        receiverMobilePhone: '', // 收件人手机号
        waybillStatusCode: 0, // 运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
        current: 1, // 当前页
        pageSize: 20, // 每页显示记录数
        orderSourceCode: ''
        // orderSourceCodes: [],
      },
      menuItems: [], // 导航栏
      activeIndex: '0',
      selection: [],
      exportVisible: false, // 导出弹框显示
      excelParams: {},
      exportStatus: 'all',
      exportType: 2, // 1：订单； 2：运单
      exportLoading: false,
      exportData: {},
      cityOptions: [],
      delTitObj: {
        title: this.$lang('删除运单'),
        subTitle: this.$lang('你确定要删除已选中的运单吗？'),
        threeTitle: ''
      },
      orderSourceCodeList: [{ groupOrderSourceName: '全部', groupOrderSourceCode: '' }],
      tabActive: 0,
      dialogExportDownVisible: false, // 下载中心
      moduleType: 'my_waybill_qy' // 我的订单
    }
  },
  async created() {
    const key = this.$route.params.typeNum
    // this.getOrderOrigin(key)
    await this.countByStatus()
    if (key) {
      this.handleSelect(key)
    } else {
      this.searchFun()
    }
  },
  computed: {
    ...mapGetters(['user', 'lang']),
    listOpt() {
      return {
        border: true,
        selection: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        rowKey: '$index',
        fixHeight: 90,
        menuWidth: 150,
        dynamicOptions: {
          // 动态列设置
          getUrl: `/vip/column/getCustomColumn`,
          saveUrl: `/vip/column/setCustomColumn`,
          defaultUrl: `/vip/column/getDefaultColumn`,
          params: {
            tableName: 'WAYBILL_LIST'
          }
        },
        //  搜索框和表格列及其字段
        column: [
          {
            label: this.$lang('运单号'),
            prop: 'waybillNo',
            width: 200,
            slot: true
          },
          {
            label: this.$lang('状态'), //  运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
            prop: 'waybillStatusCode',
            slot: true
          },
          {
            label: this.$lang('下单渠道'),
            prop: 'orderSourceName',
            width: 200
          },
          {
            label: this.$lang('客户订单号'),
            prop: 'customerOrderId',
            width: 150
          },
          {
            label: this.$lang('收件人'),
            prop: 'receiverName'
          },
          {
            label: this.$lang('收件电话'),
            prop: 'receiverMobilePhone',
            width: 100,
            formatter ({ receiverMobilePhone }) {
              return receiverMobilePhone ? `+52 ${receiverMobilePhone}` : ''
            }
          },
          {
            label: this.$lang('收件州'),
            prop: 'receiverProvinceName'
          },
          {
            label: this.$lang('收件城市'),
            prop: 'receiverCityName'
          },
          // {
          //   label: this.$lang('收件区域'),
          //   prop: 'receiverAreaName',
          // },
          {
            label: this.$lang('收件乡镇'),
            prop: 'receiverAreaName',
            width: 200
          },
          {
            label: this.$lang('收件地址1'),
            prop: 'receiverDetailedAddress',
            width: 200
          },
          {
            label: this.$lang('收件地址2'),
            prop: 'receiverDetailedAddressTwo',
            width: 200
          },
          {
            label: this.$lang('收件邮编'),
            prop: 'receiverPostalCode'
          },
          {
            label: this.$lang('物品类型'),
            prop: 'goodsTypeName'
          },
          {
            label: this.$lang('物品名称'),
            prop: 'goodsName'
          },
          {
            label: this.$lang('物品件数'),
            prop: 'packageNumber'
          },
          {
            label: this.$lang('净重'),
            prop: 'netWeight'
          },
          {
            label: this.$lang('包裹重'),
            prop: 'packageTotalWeight'
          },
          {
            label: this.$lang('物品价值'),
            prop: 'insuredAmount'
          },
          {
            label: this.$lang('保价费'),
            prop: 'insuredFee'
          },
          {
            label: this.$lang('结算方式'),
            prop: 'settlementName'
          },
          // 字段 跟总运费有冲突  先隐藏
          // {
          //   label: this.$lang('参考运费'),
          //   prop: 'totalFreight',
          //   show: this.user.freightStatus === 1,
          // },
          {
            label: this.$lang('燃油附加费'),
            prop: 'fuelCost',
            show: this.user.freightStatus === 1,
            width: 90
          },
          {
            label: this.$lang('增值税'),
            show: this.user.freightStatus === 1,
            prop: 'fuelVat'
          },
          {
            label: this.$lang('总运费'),
            show: this.user.freightStatus === 1,
            prop: 'totalFreight'
          },
          {
            label: this.$lang('备注'),
            prop: 'remarks',
            width: 200
          },
          {
            label: this.$lang('下单账号'),
            prop: 'orderAccount',
            width: 150
          },
          {
            label: this.$lang('揽收时间'),
            prop: 'collectTime',
            width: 200
          }
        ]
      }
    }
  },
  methods: {
    /**
     * @description 复制
     */
    handleCopy(data) {
      const value = data.row.waybillNo
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: this.$lang('运单号复制成功'),
        type: 'success'
      })
      oInput.remove()
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.selection = []
    },
    // 获取下单渠道下拉数据，请求列表数据
    async getOrderOrigin(key) {
      try {
        const { code, data } = await queryCustomerOrderSource()

        if (code === RESPONSE_SUCCESS) {
          if (data.length) {
            this.orderSourceCodeList = this.orderSourceCodeList.concat(data)
          } else {
            this.orderSourceCodeList = []
          }
          await this.countByStatus()
          if (key) {
            this.handleSelect(key)
          } else {
            this.searchFun()
          }
        } else {
          this.orderSourceCodeList = []
        }
      } catch (error) {
        this.orderSourceCodeList = []
      }
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.selection = []
    },
    // 查看方法
    async viewFun(row) {
      if (this.isRowDetailUrl) {
        const { data, code, msg } = await this.COM_HTTP.reqDetail({ waybillNo: row.waybillNo }) // 根据运单号
        if (code === RESPONSE_SUCCESS) {
          console.log('查看调用成功')
          // 回显数据
          const newRow = this.handleData(data)
          this.rowData = Object.assign({}, { ...newRow })
        } else {
          this.$message.error(msg)
        }
      } else {
        // 回显数据
        this.rowData = this.handleData(row)
      }
    },
    // 删除方法
    async deleteFun(item) {
      const res = await this.COM_HTTP.reqDel(item)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('删除成功'))
        this.afterDelSuccess()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 触发按钮查询
    searchChange(params) {
      const { startdate, enddate } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTime = new Date(startdate).getTime()
      const endTime = new Date(enddate).getTime()
      if (endTime - startTime > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
        return
      }
      this.searchParam.waybillStatusCode = this.menuItems[this.activeIndex].waybillStatusCode

      const { waybillNos } = this.searchParam
      // 处理运单编号
      if (waybillNos && waybillNos.length !== 0) {
        if (waybillNos.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }
      this.searchFun(1)
      this.countByStatus()
    },
    // 搜索-获取参数
    getParams() {
      const { startTime, endTime, waybillNos, receiverMobilePhone, waybillStatusCode } = this.searchParam
      return {
        pageSize: this.page.size,
        startTime: waybillNos.length ? '' : startTime,
        endTime: waybillNos.length ? '' : endTime,
        waybillNos, // 运单号
        receiverMobilePhone, // 收件人手机号
        waybillStatusCode: waybillStatusCode // 运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
        // orderSourceCodes: this.getOrderOriginCode(orderSourceCode), // 下单渠道
      }
    },
    // 导出-获取参数
    getParamForOutExcel() {
      const sort = []
      const columnNames = []
      let ids = []
      // 获取选中行的数量
      const len = (this.selection && this.selection.length) || 0
      // 选中行ids处理（未选中不穿此参数）
      if (len) ids = this.selection.map(item => item.id)
      // 处理导出表格的属性字段
      this.columnList.forEach(item => {
        sort.push(item.key)
        columnNames.push(item.name)
      })
      let params = { ids, sort, columnNames, orderStatusCode: this.exportStatus }
      if (len) params = { ...params, ids }
      else {
        params = { ...params, ...this.searchParam }
      }
      return params
    },
    // 快捷菜单搜索
    handleSelect(key) {
      const menuItems = this.menuItems
      const { waybillStatusCode } = menuItems[key]
      this.searchParam.waybillStatusCode = waybillStatusCode
      this.exportStatus = waybillStatusCode
      this.activeIndex = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.searchFun()
      this.countByStatus()
    },
    // 更新导出参数配置
    updateOutExcel(key = 0) {
      // cityOptions
      const collectTime = {
        key: 'collectTime',
        name: this.$lang('揽收时间')
      }
      const dispatchTime = {
        key: 'dispatchTime',
        name: this.$lang('派件时间')
      }
      const signTime = {
        key: 'signTime',
        name: this.$lang('签收时间')
      }
      // refundTime 退件时间？
      const refundTime = {
        key: 'refundTime',
        name: this.$lang('退件签收时间')
      }
      // inputTime 录入时间？
      const inputTime = {
        key: 'inputTime',
        name: this.$lang('运送时间')
      }
      // this.cityOptions.push(collectTime, dispatchTime, signTime, refundTime)
      switch (key) {
        case 0: // 全部运单
          this.cityOptions.push(collectTime, dispatchTime, signTime, refundTime)
          break
        case 1: // 已揽件
          this.cityOptions.push(collectTime)
          break
        case 2: // 运送中
          this.cityOptions.push(inputTime)
          break
        case 3: // 派送中
          this.cityOptions.push(dispatchTime)
          break
        case 4: // 已签收
          this.cityOptions.push(signTime)
          break
        case 5: // 退件中
          break
        case 6: // 已退件
          this.cityOptions.push(inputTime)
          break
        default:
          // 默认
          break
      }
    },
    // 删除
    delFn() {
      this.$refs.delOrder.dialogTableVisible = true
    },
    // 打开导出弹框
    async exportOpen() {
      if (this.selection.length <= 0) {
        this.exportLoading = true
        await this.countByStatus()
        this.searchFun()
        this.exportLoading = false
        const listTotal = this.menuItems[this.activeIndex].count || 0
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 100000) {
          this.$message.warning(this.$lang('导出数量超过限制'))
          return
        }
      }
      this.cityOptions = [...cityOptions]
      /**
       * @description 如果设置了 不显示参考运费 删除参考运费
       */
      if (this.user.freightStatus === 0) {
        const chooseIndex = this.cityOptions.filter(item => item.name !== '参考运费' && item.name !== '燃油附加费' && item.name !== '增值税' && item.name !== '总运费')
        this.cityOptions = chooseIndex
      }
      this.updateOutExcel(this.currentKey)
      this.exportVisible = true
      const exportData = {
        exportStatus: this.exportStatus,
        exportType: this.exportType // 1：订单； 2：运单
      }
      this.exportData = exportData
    },
    // 关闭导出弹框
    exportClose(val) {
      this.exportVisible = val
    },
    // 导出数据
    async exportFn(status, data, dataParams) {
      this.exportVisible = status
      this.columnList = data
      this.excelParams = dataParams
      // 调用导出方法
      //   await this.outExcel()
      //   改为异步导出
      await this.asyExportWaybill()
    },
    async asyExportWaybill() {
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请前往下载中心查看'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 选择日期
    selectDate() {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.startTime = start
        this.searchParam.endTime = end
      }
    },
    // 获取运单状态列表
    async countByStatus() {
      const { startTime, endTime, waybillNos, receiverMobilePhone } = this.searchParam
      const params = {
        startTime: waybillNos.length ? '' : startTime,
        endTime: waybillNos.length ? '' : endTime,
        waybillNos, // 运单号
        receiverMobilePhone // 收件人手机号
        // orderSourceCodes: this.getOrderOriginCode(orderSourceCode), // 下单渠道
      }
      const { code, data } = await countByStatus(params)
      if (code === 1) {
        this.menuItems = data
      }
    },
    getOrderOriginCode(orderSourceCode) {
      let codes = []
      if (!orderSourceCode) {
        const dataCodes = this.orderSourceCodeList.map(item => item.groupOrderSourceCode)
        codes = dataCodes
      } else {
        codes = [orderSourceCode]
      }
      return codes
    },
    closeDetails(val) {
      this.viewDialogVisible = val.viewDialogVisible
    },
    imgDialogChange(val) {
      if (val) this.viewDialogVisible = false
      if (!val) this.viewDialogVisible = true
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = {
        ids: [],
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0],
        endTime: commonFun.GetTodayDate()[1],
        orderSourceCode: ''
        // orderSourceCodes: [],
      }
      this.$refs.BaseInputTag1.clearFn()
    },
    // 表格复选框选择回调
    selectionChange(val) {
      this.selection = val
    },
    // 删除后的回调
    afterDelSuccess() {
      this.searchFun(1)
      setTimeout(this.countByStatus, 500)
    },
    changeTab(index) {
      this.tabActive = index
      this.handleSelect(index)
    },
    /**
     * 去快件查询
     */
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    }
  }
}
</script>
<style lang="scss" scoped>
// @import '@assets/iconfont/iconfont.css
::v-deep .el-form-item__label {
  line-height: 1;
  padding: 0 0 6px 0 !important;
}
.el-form-item {
  margin-bottom: 0;
}
.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}
.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}
.waybill {
  .waybill-top {
    //   padding :24px;
    padding: 16px 24px;
    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
    .waybill-topLeft {
      margin-top: 10px;
    }
  }
  .waybill-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }
  .waybill-nav {
    //   margin: 9px 0;
    .waybill-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      user-select: none;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 16px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
    //   width: 124px;
      &:first-of-type {
        margin-left: 0px;
      }
      i {
        margin-right: 8px;
        color: #666;
      }
      &.active {
        background: #fff;
        color: #e60012;
        i {
          color: #e60012;
        }
      }
    }
    .waybill-nav-item-count {
      display: inline-block;
      width: 28px;
      height: 16px;
      font-size: 10px;
      line-height: 16px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>

<style lang="scss">
.waybill .waybill-top .el-input__inner {
  margin-bottom: 10px;
}
</style>
